import React, { useEffect } from 'react';

const Form = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    script.async = true;

    script.onload = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(
          "iframe[id='JotFormIFrame-261323957156057']",
          "https://form.jotform.com/"
        );
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <iframe
        id="JotFormIFrame-261323957156057"
        title="Contact Us"
        onLoad={() => window.parent.scrollTo(0, 0)}
        allowTransparency="true"
        allow="geolocation; microphone; camera; fullscreen; payment"
        src="https://form.jotform.com/261323957156057"
        frameBorder="0"
        style={{
          minWidth: '100%',
          maxWidth: '100%',
          height: '539px',
          border: 'none',
        }}
        scrolling="no"
      />
    </div>
  );
};

export default Form;